module.exports = __webpack_public_path__ + "static/media/fourth_slide.25fb5403.jpg";